import React, { useEffect } from "react";
import SignUpForm from "../forms/pageForms/signupForm";
import { Link } from "react-router-dom";

export default function Login({}) {
  useEffect(() => {}, []);

  const handleFormikSubmit = (values, actions) => {
    console.log("Values: ", values);
    console.log("Actions: ", actions);
  };

  return (
    <main className="registration">
      <section className="main-section">
        <h2>Sign Up</h2>
        <section className="main-section-content">
          <SignUpForm handleFormikSubmit={handleFormikSubmit} />
          <hr />
          <section className="text-center mt-3">
            <div className="d-flex justify-content-around">
              <p>Already have an account?</p>
              <Link to="/">LOGIN</Link>
            </div>
          </section>
        </section>
      </section>
    </main>
  );
}
